export const toRecordBy = <T>(items: T[], key: keyof T): Record<string, T> =>
  items.reduce<Record<string, T>>((acc, item) => {
    acc[item[key] as string] = item;
    return acc;
  }, {});
